import { memo } from "react";
import { FeedCurve } from "../../../../Services";
import { useTranslation } from "react-i18next";
import { colors, fonts, glyphs } from "../../../../Styles";
import CurveInfoBox from "./curveInfoBox";

const InfoBoxGeneral = memo(({ feedCurve, amountOfDays, noColors }: { feedCurve: FeedCurve, amountOfDays: number, noColors?: boolean }) => {
  const { t } = useTranslation();

  const fallbackTexts = {
    spreadings: t("feedCurvePages.feedCurve.noSpreading", { defaultValue: "No Spreading" }),
  };

  const displayData: Record<string, { value?: string | number | JSX.Element, unit?: string }> = {
    feedCurveLenght: { value: amountOfDays, unit: amountOfDays === 1 ? t("units.day", { defaultValue: "day" }) : t("units.days", { defaultValue: "days" }) },
    spreadings: { value: feedCurve.times?.length !== 0 ? feedCurve.times?.length : undefined, unit: feedCurve.times?.length === 1 ? t("feedCurvePages.feedCurve.feeding", { defaultValue: "feeding" }) : t("feedCurvePages.feedCurve.feedings", { defaultValue: "feedings" }) },
    passFeed: { value: feedCurve.passFeed === 0 ? <glyphs.Minus size='15px' fillColor={colors.systemRed} /> : Math.round(feedCurve.passFeed / 1000), unit: feedCurve.passFeed === 0 ? undefined : `${t("units.kg", { defaultValue: "KG" })} ${t("feedCurvePages.feedCurve.max", { defaultValue: "max" })}` },
    stimuli: { value: feedCurve.stimuli === 0 ? <glyphs.Minus size='15px' fillColor={colors.systemRed} /> : t("feedCurvePages.feedCurve.singleStimuli", { defaultValue: "Single Stimuli" }) },
    feedLimit: { value: feedCurve.feedLimit === 0 ? <glyphs.Minus size='15px' fillColor={colors.systemRed} /> : Math.round(feedCurve.feedLimit / 1000), unit: feedCurve.feedLimit === 0 ? undefined : `${t("units.kg", { defaultValue: "KG" })} ${t("feedCurvePages.feedCurve.max", { defaultValue: "max" })}` },
  }

  return (
    <CurveInfoBox
      header={t("general")}
      data={{
        displayData: displayData,
        fallbackTexts: fallbackTexts
      }}
      splitView
      overrides={{
        noColors: noColors,
        width: noColors === true ? "fit-content" : "230px"
      }}
    />
  )
})

export default InfoBoxGeneral